import { AbacVisibility } from '@infuse/api/common';

export interface CentralSystem {
  id: number;
  name: string;
  type: ConnectionType;
  ocppVersion: OcppVersion;
  uri?: string;
  readonly: boolean;
  visibility?: AbacVisibility;
}

export enum ConnectionType {
  SOAP = 'SOAP',
  WEBSOCKET = 'WEBSOCKET',
  AWS_SNS = 'AWS_SNS',
  AWS_IOT = 'AWS_IOT',
  JAVA_API = 'JAVA_API'
}

export enum OcppVersion {
  V15 = '1.5',
  V16 = '1.6'
}

export interface LinkedCentralSystem {
  centralSystemId: number;
  chargingStationId: number;
  type: LinkedCentralSystemType;
  customChargingStationName: string;
  commandsAllowed: boolean;
  sessionAuthorizationAllowed: boolean;
  forwardBasicAuth: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export enum LinkedCentralSystemType {
  MASTER = 'MASTER',
  READONLY = 'READONLY'
}
